import React from 'react'
import { connect } from 'react-redux'
import { hasChangedValues, getFormValue, changeItemsValue } from 'tyan/public/utility/formValues'
import TreeSelect from 'tyan/business/TreeSelect'
class DocumentDraftingDiv extends React.Component {
    state = {
    }

    componentDidMount = () => {
        this.GetQualityFileApply(this.props.id)
    }

    GetQualityFileApply = (id) => {
        Tyan.doPostEvent({
            event: 'GetQualityFileApply',
            data: {
                id: id || 0,
            },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
            }
        })
    }

    handlerSave = () => {
        const { id, changedValues基本信息, } = this.state
        const { dispatch, onSave, onClose } = this.props
        Tyan.doPostEvent({
            event: 'SaveQualityFileApply',
            data: {
                id, changedValues基本信息,
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                else {
                    Ext.toast('保存成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        })
    }

    handlerDelete = () => {
        const { dispatch, onClose, onSave } = this.props
        const { id } = this.state

        Tyan.pubForm.showConfirm('确定要删除？', () =>

            Tyan.doPostEvent({
                event: 'DeleteQualityFileApply',
                data: {
                    id
                },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            })
        )
    }

    handlerClose = () => {
        const { onClose, roles } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }


    canSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }

        return this.bChanged() && getFormValue(this, '基本信息', '文件名称') &&
            getFormValue(this, '基本信息', '文件状态') &&
            getFormValue(this, '基本信息', 'fullName') &&
            getFormValue(this, '基本信息', '发放范围')
    }

    bChanged = () => {
        return hasChangedValues(this)
    }


    handleShowDiv = (initValues, onConfirm, onDelete) => {
        Tyan.pubForm.showDialog(initValues.title, props => <TreeSelect {...props} initValues={initValues} onConfirm={onConfirm} onDelete={onDelete} />)
    }


    fieldset基本信息 = () => {
        //const { roles } = this.props
        const { initValues基本信息, changedValues基本信息, optionsParas } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息, ...optionsParas }
        return [
            { _text: '文件编号', name: '文件编号', minWidth: '40%' },
            { _text: '文件状态', editable: true, minWidth: '40%', disabled: true },
            { _text: '文件名称', required: true, minWidth: '40%' },
            { _text: '版别', minWidth: '40%' },
            {
                _text: '所属目录', name: 'fullName', minWidth: '40%', disabled: true,
                button: {
                    text: "...",
                    handler: () => this.handleShowDiv(
                        { title: '所属目录', ...values.arr目录, ...values.obj目录, treeName: values.treeName, treeField: values.treeField },
                        (changedValues) => changeItemsValue(this, '基本信息', ['fatherID', 'fullName'], [changedValues['fatherID'], changedValues['fullName']]),
                    ),
                }
            },
            { _text: '起草理由', minWidth: '40%' },

            { _select: '起草人', minWidth: '40%', editable: true },
            { _date: '起草日期', minWidth: '40%' },
            { _select: '发放范围', minWidth: '40%', multiSelect: true, required: true, },
            { _files: '文件', accept: '.doc,.docx', multiple: false, limit: 0/*default*/, minWidth: '90%', },
            { _text: '备注', minWidth: '90%', maxRows: 3 },

        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, roles } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={Tyan.t('请稍等 ...')} />
        const { 文件状态 } = initValues基本信息
        return <Body data={this} maxWidth="1100"
            controls={
                [
                    { _flow: 'QualityFileApplyFlow', disabled: this.bChanged(), cdt: () => id > 0 },
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.canSave(), cdt: () => 文件状态 == '编制中' },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => 文件状态 == '编制中' },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: 文件状态 != '编制中' },
                ]}
        />
    }
}

export default connect()(DocumentDraftingDiv)